import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import dwarfAnvil from '../assets/dwarf_anvil.svg';

const NotFound = () => {
  useEffect(() => {
    document.title = '404 - Page Not Found | ä.dk';
    
    // Create and update meta tags
    const metaTags = {
      'description': 'Page not found. This URL does not exist on ä.dk.',
      'robots': 'noindex, nofollow'
    };

    // Add or update meta tags
    Object.entries(metaTags).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Cleanup function
    return () => {
      Object.keys(metaTags).forEach(name => {
        const meta = document.querySelector(`meta[name="${name}"]`);
        if (meta) {
          document.head.removeChild(meta);
        }
      });
    };
  }, []);

  return (
    <div className="page-container">
      <Navigation />
      <main className="main-content">
        <div className="container">
          <div className="flex" style={{ alignItems: 'center', minHeight: '50vh' }}>
            <div className="col">
              <h1 className="heading-2">404 - Page Not Found</h1>
              <p>Oops! This URL doesn't exist. Maybe it was a temporary short URL that expired?</p>
              <div style={{ marginTop: '2rem' }}>
                <Link to="/" className="button button-primary">Go to Homepage</Link>
              </div>
            </div>
            <div className="col">
              <img src={dwarfAnvil} alt="" className="illu img-responsive" style={{ maxWidth: '300px' }} />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
